import employeesApi from "../../api/employees"
import workloadsApi from "../../api/workloads"
import courseEquivalentsApi from "../../api/courseEquivalents"
import * as _ from "lodash" // eslint-disable-line no-unused-vars

const state = {
  employeeJobs: [],
  workloadTypeDefinitions: [],
  files: [],
  workload: {
    asuriteId: "",
    courses: [],
    timePeriod: null,
    workloadTypes: [],
    workloadFiles: [],
    buyoutRequests: [],
    overageRequests: [],
    administrativeRequests: [],
    affiliateWorkRequests: [],
  },
  courseEquivalents: [],
}

const getters = {}

const actions = {
  getEmployeeJobs(context, asuriteId) {
    return new Promise((resolve, reject) => {
      employeesApi
        .getEmployeeJobs(asuriteId)
        .then(function(response) {
          context.commit("updateEmployeeJobs", response.data)
          resolve(response)
        })
        .catch(function(error) {
          console.log(error)
          reject(error)
        })
    })
  },

  getWorkloadTypeDefinitions(context) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getWorkloadTypeDefinitions()
        .then(function(response) {
          context.commit("updateWorkloadTypeDefinitions", response.data)
          resolve(response)
        })
        .catch(function(error) {
          console.log(error)
          reject(error)
        })
    })
  },

  getCourseEquivalents(context, args) {
    // get a list of termIds from timeperiod
    var termIds = _.map(args.timePeriod.timePeriodTerms, function(
      timePeriodTerm
    ) {
      return timePeriodTerm.termId
    })
    // clear course equivalents first
    context.commit("clearCourseEquivalents")

    // for each termId in termIds, call the api to get course equivalents
    _.forEach(termIds, function(termId) {
      courseEquivalentsApi
        .getByTermAndAsurite(termId, args.asuriteId)
        .then((response) => {
          //this.courseEquivalents.push(response.data);
          context.commit("updateCourseEquivalents", response.data)
        })
    })
  },

  initializeFromId(context, workloadId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getWorkloadById(workloadId)
        .then(function(response) {
          context.commit("updateAsurite", response.data.asuriteId)
          // populate type values
          _.forEach(response.data.workloadTypes, function(workloadType) {
            context.commit("updateWorkloadTypeValue", workloadType)
            context.commit("updateWorkloadTypeNotes", workloadType)
          })
          context.commit("updateWorkloadBuyouts", response.data.buyoutRequests)
          context.commit("updateWorkloadTimePeriod", response.data.timePeriod)
          context.commit("updateWorkloadCourses", response.data.courses)
          context.commit("updateWorkloadFiles", response.data.workloadFiles)
          context.commit(
            "updateWorkloadOverageRequests",
            response.data.overageRequests
          )
          context.commit(
            "updateWorkloadAdministrativeRequests",
            response.data.administrativeRequests
          )
          context.commit(
            "updateWorkloadAffiliateRequests",
            response.data.affiliateWorkRequests
          )

          context.dispatch("getCourseEquivalents", {
            timePeriod: response.data.timePeriod,
            asuriteId: response.data.asuriteId,
          })

          resolve(response)
        })
        .catch(function(error) {
          console.log(error)
          reject(error)
        })
    })
  },

  initializeWorkloadTypes(context) {
    var workloadTypes = []
    _.forEach(state.workloadTypeDefinitions, function(workloadTypeDefinition) {
      var workloadType = {
        value: 0,
        workloadTypeDefinitionId:
          workloadTypeDefinition.workloadTypeDefinitionId,
        workloadTypeDefinition: workloadTypeDefinition,
        notes: null,
      }
      workloadTypes.push(workloadType)
    })
    context.commit("updateWorkloadTypes", workloadTypes)
  },

  populateCoursesFromLastWorkload(context, asuriteId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getLastWorkload(asuriteId)
        .then(function(response) {
          var previousCourses = response.data.courses
          var courses = []

          // update TermId for each of these courses
          _.forEach(previousCourses, function(previousCourse) {
            var newCourse = previousCourse
            var semesterSeasonDescriptor = null

            if (previousCourse.term.description.includes("Spring")) {
              semesterSeasonDescriptor = "Spring"
            } else if (previousCourse.term.description.includes("Summer")) {
              semesterSeasonDescriptor = "Summer"
            } else {
              semesterSeasonDescriptor = "Fall"
            }

            var correspondingTerm = _.find(
              state.workload.timePeriod.timePeriodTerms,
              function(timePeriodTerm) {
                return timePeriodTerm.term.description.includes(
                  semesterSeasonDescriptor
                )
              }
            )
            if (correspondingTerm) {
              newCourse.termId = correspondingTerm.termId
              newCourse.term = null
              courses.push(newCourse)
            }
          })

          context.commit("updateWorkloadCourses", courses)
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
        })
    })
  },

  populateFacultyWorkload(context) {
    // setting to 40/40/20
    var teaching = _.find(context.state.workload.workloadTypes, function(
      workloadType
    ) {
      return workloadType.workloadTypeDefinition.name === "Teaching"
    })

    var research = _.find(context.state.workload.workloadTypes, function(
      workloadType
    ) {
      return workloadType.workloadTypeDefinition.name === "Research"
    })

    var service = _.find(context.state.workload.workloadTypes, function(
      workloadType
    ) {
      return workloadType.workloadTypeDefinition.name === "Service"
    })

    if (teaching) {
      teaching.value = 0.4
      context.commit("updateWorkloadTypeValue", teaching)
    }

    if (research) {
      research.value = 0.4
      context.commit("updateWorkloadTypeValue", research)
    }

    if (service) {
      service.value = 0.2
      context.commit("updateWorkloadTypeValue", service)
    }
  },

  populateFromLastWorkload(context, args) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .getLastWorkload(args.asuriteId)
        .then(function(response) {
          // if response.data is "", then there is no previous workload
          if (response.data) {
            // populate type values
            _.forEach(response.data.workloadTypes, function(workloadType) {
              context.commit("updateWorkloadTypeValue", workloadType)
            })

            // populate all data if submitting on behalf of another faculty
            if (
              args.submittingOnBehalf &&
              response.data.timePeriod.timePeriodId === args.timePeriodId
            ) {
              context.commit(
                "updateWorkloadBuyouts",
                response.data.buyoutRequests
              )
              context.commit(
                "updateWorkloadTimePeriod",
                response.data.timePeriod
              )
              context.commit("updateWorkloadCourses", response.data.courses)
              context.commit("updateWorkloadFiles", response.data.workloadFiles)
              context.commit(
                "updateWorkloadOverageRequests",
                response.data.overageRequests
              )
              context.commit(
                "updateWorkloadAdministrativeRequests",
                response.data.administrativeRequests
              )
              context.commit(
                "updateWorkloadAffiliateRequests",
                response.data.affiliateWorkRequests
              )
            }
          }
          resolve(response)
        })
        .catch(function(error) {
          console.log(error)
          reject(error)
        })
    })
  },

  addWorkload(context) {
    var formData = new FormData()
    formData.append("data", JSON.stringify(context.state.workload))

    _.forEach(context.state.files, function(file) {
      // add each file to the form data
      formData.append("files[]", file)
    })

    return new Promise((resolve, reject) => {
      workloadsApi
        .postWorkload(formData)
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
        })
    })
  },

  sendWorkloadSubmittedEmail(context, workloadId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .createWorkloadSubmittedEmail(workloadId)
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
        })
    })
  },

  sendWorkloadSubmittedBehalfEmail(context, workloadId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .createWorkloadSubmittedBehalfEmail(workloadId)
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
        })
    })
  },

  sendRevisionEmail(context, workloadId) {
    return new Promise((resolve, reject) => {
      workloadsApi
        .createRevisionEmail(workloadId)
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
        })
    })
  },
}

const mutations = {
  addFile(state, value) {
    state.files.push(value)
  },

  updateAsurite(state, value) {
    state.workload.asuriteId = value
  },

  updateEmployeeJobs(state, value) {
    state.employeeJobs = value
  },

  updateWorkloadTermCourses(state, workloadTermObject) {
    var updatedWorkloadTerm = _.find(state.workload.workloadTerms, function(
      workloadTerm
    ) {
      return workloadTerm.termId === workloadTermObject.termId
    })
    updatedWorkloadTerm.workloadTermCourses =
      workloadTermObject.workloadTermCourses
  },

  updateWorkloadCourses(state, value) {
    state.workload.courses = value
  },

  updateWorkloadBuyouts(state, value) {
    state.workload.buyoutRequests = value
  },

  updateWorkloadAdministrativeRequests(state, value) {
    state.workload.administrativeRequests = value
  },

  updateWorkloadAffiliateRequests(state, value) {
    state.workload.affiliateWorkRequests = value
  },

  updateWorkloadOverageRequests(state, value) {
    state.workload.overageRequests = value
  },

  updateWorkloadFiles(state, value) {
    state.workload.workloadFiles = value
  },

  updateWorkloadTypes(state, value) {
    state.workload.workloadTypes = value
  },

  updateWorkloadTypeDefinitions(state, value) {
    state.workloadTypeDefinitions = value
  },

  updateWorkloadTimePeriod(state, value) {
    state.workload.timePeriod = value
  },
  updateWorkloadTypeValue(state, workloadTypeObject) {
    var updatedWorkloadType = _.find(state.workload.workloadTypes, function(
      workloadType
    ) {
      return (
        workloadType.workloadTypeDefinitionId ===
        workloadTypeObject.workloadTypeDefinitionId
      )
    })
    updatedWorkloadType.value = workloadTypeObject.value
    updatedWorkloadType.notes = workloadTypeObject.notes
  },

  updateWorkloadTypeNotes(state, workloadTypeObject) {
    var updatedWorkloadType = _.find(state.workload.workloadTypes, function(
      workloadType
    ) {
      return (
        workloadType.workloadTypeDefinitionId ===
        workloadTypeObject.workloadTypeDefinitionId
      )
    })
    updatedWorkloadType.notes = workloadTypeObject.notes
  },

  updateWorkloadEmployee(state, value) {
    state.workload.asuriteId = value
  },

  updateCourseEquivalents(state, value) {
    state.courseEquivalents.push(...value)
  },
  clearCourseEquivalents(state) {
    state.courseEquivalents = []
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
